export default __webpack_public_path__ + "static/media/takeaway.2be28110.png";